// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4o-0";
export var startPickingButton = "_4o-1";